module.exports = __webpack_public_path__ + "static/main-e22dc2f33b9d455a5a56dda5b5da0f9f.jpg";